import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-4 left-4 right-4 sm:left-1/2 sm:right-auto sm:-translate-x-1/2 sm:w-[380px] z-[9999] bg-white dark:bg-gray-900 rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 dark:border-gray-800 p-2 pl-3 flex items-center justify-between transition-all duration-300"
}
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "w-8 h-8 relative flex items-center justify-center flex-shrink-0" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex items-center gap-2 pr-1" }

import { useTitle } from '@/composables/ui/useTitle'
import { useColorScheme } from '@/composables/ui/useColorScheme'
import { computed, onMounted, ref } from 'vue'
import { useThemeStore } from '@/stores/theme'
import ToastContainer from '@/components/layout/ToastContainer.vue'
import { usePWAInstall } from '@/composables/ui/usePWAInstall'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { isInstallable, promptInstall } = usePWAInstall()
const dismissedInstall = ref(false)
const publicPath = process.env.BASE_URL || '/'

const dismissInstall = () => {
  dismissedInstall.value = true
}

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'PLANET Home Healthcare')
useTitle(appTitle.value)

useColorScheme()

const themeStore = useThemeStore()

onMounted(() => {
  	themeStore.initializeTheme()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "slide-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }),
    _createVNode(ToastContainer),
    (_unref(isInstallable) && !dismissedInstall.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: `${_unref(publicPath)}icons/favicon-96x96.png`,
                alt: "App Icon",
                class: "w-full h-full object-contain drop-shadow-sm"
              }, null, 8, _hoisted_4)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-semibold text-[15px] text-gray-900 dark:text-gray-100" }, "Install App", -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(promptInstall) && _unref(promptInstall)(...args))),
              class: "px-5 py-1.5 bg-[#4F46E5] text-white text-[14px] font-medium rounded-md hover:bg-[#4338CA] transition-colors shadow-sm tracking-wide"
            }, " Install "),
            _createElementVNode("button", {
              onClick: dismissInstall,
              class: "p-1 px-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors",
              "aria-label": "Close"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                class: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "1.5",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})